(() => {
  const init = () => {
    const root = document.getElementById('obm-story');
    if (!root || root.dataset.initialised) return;
    root.dataset.initialised = 'true';
    const sticky = root.querySelector('#obm-story-sticky');
    const boundary = root.querySelector('#obm-story-for-you');
    const finalCta = root.querySelector('#obm-story-final-cta');
    const mobile = window.matchMedia('(max-width: 767px)');
    let queued = false;
    const update = () => {
      queued = false;
      const finalRect = finalCta.getBoundingClientRect();
      const reachedCards = boundary.getBoundingClientRect().top < window.innerHeight - 100;
      const beforeFinal = finalRect.top >= window.innerHeight;
      const show = mobile.matches && reachedCards && beforeFinal;
      sticky.hidden = !show;
    };
    const schedule = () => { if (!queued) { queued = true; requestAnimationFrame(update); } };
    window.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', schedule, { passive: true });
    new ResizeObserver(schedule).observe(root);
    update();
    root.addEventListener('click', (event) => {
      const link = event.target.closest('a[data-story-click]');
      if (!link || !root.contains(link)) return;
      const data = {
        page: 'olivias-story',
        button_id: link.dataset.storyClick,
        placement: link.dataset.storyPlacement,
        destination: new URL(link.href, location.origin).pathname,
        label: link.textContent.trim().replace(/\s+/g, ' '),
        product_handle: link.dataset.storyProduct || null,
        device_layout: mobile.matches ? 'mobile' : 'desktop'
      };
      root.dispatchEvent(new CustomEvent('obm:story-click', { detail: data, bubbles: true }));
      if (root.dataset.preview === 'true') {
        root.dataset.lastPreviewClick = data.button_id;
        console.info('OBM story preview click', JSON.stringify(data));
        return;
      }
      try {
        const publish = window.Shopify?.analytics?.publish;
        if (typeof publish === 'function') {
          Promise.resolve(window.Shopify.analytics.publish('obm:story_click', data)).catch(() => {});
        }
      } catch (_) {}
      const privacy = window.Shopify?.customerPrivacy;
      if (privacy?.analyticsProcessingAllowed?.() !== true) return;
      if (typeof window.gtag === 'function') {
        window.gtag('event', 'obm_story_click', { ...data, transport_type: 'beacon' });
      } else if (Array.isArray(window.dataLayer)) {
        window.dataLayer.push({ event: 'obm_story_click', ...data });
      }
    });
    for (const video of root.querySelectorAll('video')) {
      video.addEventListener('loadedmetadata', () => {
        for (const track of video.textTracks) if (track.kind === 'captions') track.mode = 'showing';
      });
    }
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
  document.addEventListener('shopify:section:load', init);
})();
